import { AlertType } from '../enums/alert-type.enum';
import { ConfigService } from 'src/app/core/services/config.service';
import { Direction } from '@angular/cdk/bidi';
import { DOCUMENT } from '@angular/common';
import {
  IAlertOptions,
  IMessage,
} from 'src/app/shared/interfaces/ialert-options';
import { Inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';
import {AlertPopupComponent} from "../components/alert-popup/alert-popup.component";

@Injectable({
  providedIn: 'root',
})
export class AlertPopupService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    public snackBar: MatSnackBar,
    @Inject(DOCUMENT) private document: Document,
    private configService: ConfigService
  ) {}

  showAlert(snackBarPopupDetails: IAlertOptions, customPopupComponent?: any) {
    let snackBarOptions: MatSnackBarConfig = {
      horizontalPosition:
        snackBarPopupDetails.horizontalPosition || this.horizontalPosition,
      verticalPosition:
        snackBarPopupDetails.verticalPosition || this.verticalPosition,
      data: snackBarPopupDetails,
      direction: this.document.documentElement.getAttribute('dir') as Direction,
    };
    if (snackBarPopupDetails.autoClose) {
      snackBarOptions['duration'] =
        snackBarPopupDetails.duration ||
        this.configService.config.alertOptions.duration;
    }
    this.snackBar.openFromComponent(
      customPopupComponent || AlertPopupComponent,
      snackBarOptions
    );
  }

  showAlertMessage(message: IMessage | string, type: AlertType) {
    this.snackBar.openFromComponent(AlertPopupComponent, {
      data: this.getConstructedAlertData(message, type),
      duration: this.configService.config.alertOptions.duration,
      direction: this.getDirection(),
    });
  }

  showInfoAlert(message: IMessage | string) {
    this.snackBar.openFromComponent(AlertPopupComponent, {
      data: this.getConstructedAlertData(message, AlertType.info),
      duration: this.configService.config.alertOptions.duration,
      direction: this.getDirection(),
      verticalPosition: this.verticalPosition,
    });
  }

  showWarningAlert(message: IMessage | string) {
    this.snackBar.openFromComponent(AlertPopupComponent, {
      data: this.getConstructedAlertData(message, AlertType.warning),
      duration: this.configService.config.alertOptions.duration,
      direction: this.getDirection(),
      verticalPosition: this.verticalPosition,
    });
  }

  showErrorAlert(message: IMessage | string) {
    this.snackBar.openFromComponent(AlertPopupComponent, {
      data: this.getConstructedAlertData(message, AlertType.error),
      duration: this.configService.config.alertOptions.duration,
      direction: this.getDirection(),
      verticalPosition: this.verticalPosition,
    });
  }

  getConstructedAlertData(message: IMessage | string, type: AlertType) {
    let messages = [message];
    if (typeof message === 'string') {
      messages = [
        {
          text: message,
        },
      ];
    }
    const data = {
      messages: messages,
      type: type,
    };

    return data;
  }

  private getDirection(): Direction {
    return this.document.documentElement.getAttribute('dir') as Direction;
  }
}
